import React, { PropTypes } from 'react';
import { reduxForm } from 'redux-form';
import RichEditor from '../form/RichEditor';
import RaisedButton from 'material-ui/RaisedButton';

class SettingsEditForm extends React.Component {
  static propTypes = {
    cancel: PropTypes.func.isRequired,
    submit: PropTypes.func.isRequired

  };

  render() {
    let {
      fields: {
        terms_and_conditions,
        data_security
      },
      cancel,
      submit,
      handleSubmit,
      submitting
    } = this.props;

    return (
      <form onSubmit={handleSubmit(submit)} style={{padding: 16}}>
        <RichEditor label="Terms of Service" {...terms_and_conditions}/>
        <RichEditor label="Privacy Policy" {...data_security}/>
        <br/>
        <RaisedButton label="Save" type="submit" primary disabled={true}/>
        {' '}
        <RaisedButton label="Cancel" primary disabled={submitting} onClick={cancel}/>
      </form>
    );
  }
}

export default reduxForm(
  {
    form: 'settings_edit_form',
    fields: ['terms_and_conditions', 'data_security']
  },
  state => ({
    initialValues: state.settings.formValues
  })
)(SettingsEditForm);



// WEBPACK FOOTER //
// ./src/components/Settings/SettingsEditForm.jsx